
import ogPagesMixins from '@/mixins/ogPagesMixins'
export default {
  mixins: [ogPagesMixins],
  layout: 'base',
  async asyncData({ $axios }) {
    const { streams, countAllStreams } = await $axios.$get('/streams', {
      params: {
        limit: 12,
      },
    })
    return { streams, countAllStreams }
  },
  data() {
    return {
      seoTitle: 'Реклама | Мегасреда',
      seoDescription:
        'Сообщество объединяет всех современных бухгалтеров, юристов и предпринимателей для совместного достижения амбициозных целей',
      streams: null,
      countAllStreams: 0,

      seoImage: {
        url: 'https://megasreda.ru/img/about/index.jpg',
        urlVk: 'https://megasreda.ru/img/about/index-vk.jpg',
        urlTw: 'https://megasreda.ru/img/about/index.jpg',
        type: 'image/jpeg',
        width: 1200,
        height: 630,
      },
    }
  },
}
